'use client';

import { Box, Stack, Link } from "@chakra-ui/react";
import ContentBox from "@/components/partials/ContentBox";

export default function Talks2Us() {
  return (
    <ContentBox text="Fale conosco" padding="0" smallText={true}>
      <Stack gap="1" textAlign="center" fontSize="1.3em" pt="2" pb="4">
        <Box>
          <Link href="mailto:redacao@agora1.info" title="Enviar email para redacao@agora1.info" target="_blank" _hover={{color: 'orange.500'}}>
            redacao@agora1.info
          </Link>
        </Box>

        <Box>
          <Link href="https://api.whatsapp.com/send?phone=5542991416720" title="Enviar whatsapp para 42 9 9141 6720" target="_blank" _hover={{color: 'orange.500'}}>
            42 9 9141 6720
          </Link>
        </Box>
      </Stack>
    </ContentBox>
  )
}
